import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import * as branchUserTypes from '../store/modules/branch-user-types'

Vue.mixin({
  data () {
    return {
      env: process.env.NODE_ENV
    }
  },
  computed: {
    ...mapGetters([
      'isSelectedUserTypeOf'
    ]),
    ...mapGetters({
      user: 'authentication/user',
      loggedIn: 'authentication/check'
    }),
    isSelfMode () {
      return this.$store.state.isSelf
      // return false;
    },
    isBfmLogin () {
      return this.$store.state.isBfmLogin
      // return true;
    },
    isSelfSignInLogin () {
      return this.$store.state.isSelfSignInLogin
      // return false;
    },
    isBfm () {
      return this.isSelectedUserTypeOf(branchUserTypes.BFM)
    },
    isResident () {
      return this.isSelectedUserTypeOf(branchUserTypes.RESIDENT)
    },
    isContact () {
      return this.isSelectedUserTypeOf(branchUserTypes.CONTACT)
    },
    isProvider () {
      return this.isSelectedUserTypeOf(branchUserTypes.PROVIDER)
    },
    isVisitor () {
      return this.isSelectedUserTypeOf(branchUserTypes.VISITOR)
    },
    userState () {
      return this.user.state.toUpperCase()
    },
    isKioskEnabled () {
      // If we're in dev, return true.
      // if (this.$store.state.kioskEnabled) {
      //   console.log(this.$store.state.kioskEnabled)
      //   return true
      // }
      console.log(this.$store.state.kioskUsername)
      return this.$store.state.kioskEnabled
    }
  },
  methods: {
    ...mapActions([
      'setPageAlertInformation'
    ]),
    goHome () {
      this.$router.push({ name: 'home' })
    },
    availableForms () {
      this.$router.push({ name: 'available-forms' })
    },
    isEmptyObject (obj) {
      return Object.keys(obj).length === 0 && obj.constructor === Object
    },
    isMissing (isError) {
      return (!isError) ? null : false
    }
  }
})
